import { ApiResponse } from '@/api/base';
import { useCommonStore } from '@/store';

export const fetchToStore = async (
  fetchFunction: () => Promise<ApiResponse<unknown>>,
  storeKey: string,
  pendingKey?: string
) => {
  pendingKey && useCommonStore.setState({ [pendingKey]: true });
  return fetchFunction()
    .then(({ data }) => {
      if (!data) return;
      useCommonStore.setState({ [storeKey]: data });
    })
    .finally(() => {
      pendingKey && useCommonStore.setState({ [pendingKey]: false });
    });
};
